(function(){
  function setup(){
    if(document.body.dataset.selfNotifyDone) return;
    document.body.dataset.selfNotifyDone='1';

    if(!document.getElementById('self-notify-overlay')){
      var ov=document.createElement('div');
      ov.id='self-notify-overlay';
      ov.className='self-notify-overlay';
      document.body.appendChild(ov);
    }

    var overlay=document.getElementById('self-notify-overlay');

    if(!document.getElementById('self-notify-popup')){
      var pop=document.createElement('div');
      pop.id='self-notify-popup';
      pop.className='self-notify-popup';
      pop.innerHTML='<div class="self-notify-popup-header"><span class="self-notify-popup-title"></span><button class="self-notify-close" aria-label="close">&#x2715;</button></div><p class="self-notify-popup-subtitle">we\'ll notify you when it\'s back</p><div class="self-notify-sizes"></div><form class="self-notify-form" novalidate><input type="email" class="self-notify-email" placeholder="your email" required autocomplete="email" /><button type="submit" class="self-notify-submit" disabled>keep me posted</button></form><p class="self-notify-msg" style="display:none;"></p>';
      overlay.appendChild(pop);
    }

    var popup=document.getElementById('self-notify-popup');
    var titleEl=popup.querySelector('.self-notify-popup-title');
    var closeBtn=popup.querySelector('.self-notify-close');
    var sizesEl=popup.querySelector('.self-notify-sizes');
    var emailEl=popup.querySelector('.self-notify-email');
    var submitBtn=popup.querySelector('.self-notify-submit');
    var msgEl=popup.querySelector('.self-notify-msg');
    var form=popup.querySelector('.self-notify-form');
    var subtitleEl=popup.querySelector('.self-notify-popup-subtitle');
    var activeProductId=null;
    var activeVariantId=null;

    function openPopup(wrap){
  var variants=[];
  try{ variants=JSON.parse(wrap.dataset.variants); }catch(e){}
  var options=[];
  try{ options=JSON.parse(wrap.dataset.options); }catch(e){}
  var hasOnlyDefault=wrap.dataset.hasOnlyDefault==='true';
  activeProductId=wrap.dataset.productId;
  activeVariantId=wrap.dataset.variantId;

  titleEl.textContent=wrap.dataset.productTitle;
  titleEl.style.display='';
  sizesEl.innerHTML='';
  sizesEl.style.display='';
  emailEl.value='';
  submitBtn.disabled=true;
  msgEl.style.display='none';
  msgEl.innerHTML='';
  form.style.display='flex';

  var selectedOptions={};

  function findVariant(){
    for(var i=0;i<variants.length;i++){
      var v=variants[i];
      if(!v.options) continue;
      var match=true;
      for(var j=0;j<options.length;j++){
        if(v.options[j]!==selectedOptions[j]){ match=false; break; }
      }
      if(match) return v;
    }
    return null;
  }

  function updateSubmit(){
    var allSelected=Object.keys(selectedOptions).length===options.length;
    if(!allSelected){ submitBtn.disabled=true; return; }
    var v=findVariant();
    if(v){ activeVariantId=String(v.id); submitBtn.disabled=false; }
    else { submitBtn.disabled=true; }
  }

  if(!hasOnlyDefault&&options.length>1){
    subtitleEl.style.display='block';
    options.forEach(function(opt,optIndex){
      var label=document.createElement('p');
      label.style.cssText='font-size:12px;opacity:.6;margin:0 0 6px;text-transform:lowercase;';
      label.textContent=opt.name.toLowerCase();

      var selectWrap=document.createElement('div');
      selectWrap.className='self-notify-select-wrap';

      var select=document.createElement('select');
      select.className='self-notify-select';

      var placeholder=document.createElement('option');
      placeholder.value='';
      placeholder.textContent='select '+opt.name.toLowerCase();
      placeholder.disabled=true;
      placeholder.selected=true;
      select.appendChild(placeholder);

      opt.values.forEach(function(val){
        var o=document.createElement('option');
        o.value=val;
        o.textContent=val.toLowerCase();
        select.appendChild(o);
      });

      select.addEventListener('change',function(){
        selectedOptions[optIndex]=select.value;
        updateSubmit();
      });

      selectWrap.appendChild(select);
      sizesEl.appendChild(label);
      sizesEl.appendChild(selectWrap);
     

    });
  } else if(!hasOnlyDefault&&options.length===1){
    subtitleEl.style.display='block';
    var label=document.createElement('p');
    label.style.cssText='font-size:12px;opacity:.6;margin:0 0 6px;text-transform:lowercase;';
    label.textContent=options[0].name.toLowerCase();

    var selectWrap=document.createElement('div');
    selectWrap.className='self-notify-select-wrap';

    var select=document.createElement('select');
    select.className='self-notify-select';

    var placeholder=document.createElement('option');
    placeholder.value='';
    placeholder.textContent='select '+options[0].name.toLowerCase();
    placeholder.disabled=true;
    placeholder.selected=true;
    select.appendChild(placeholder);

    options[0].values.forEach(function(val){
      var o=document.createElement('option');
      o.value=val;
      o.textContent=val.toLowerCase();
      select.appendChild(o);
    });

    select.addEventListener('change',function(){
      selectedOptions[0]=select.value;
      updateSubmit();
    });

    selectWrap.appendChild(select);
    sizesEl.appendChild(label);
    sizesEl.appendChild(selectWrap);
  }else {
    subtitleEl.style.display='none';
    submitBtn.disabled=false;
  }

  overlay.classList.add('open');
  popup.classList.add('open');
  document.body.style.overflow='hidden';
  document.documentElement.style.overflow='hidden';
}

    window.openSelfNotifyPopup=openPopup;

    function closePopup(){
      emailEl.blur();
      overlay.classList.remove('open');
      popup.classList.remove('open');
      document.body.style.overflow='';
      document.documentElement.style.overflow='';
      sizesEl.style.display='';
      form.style.display='';
      titleEl.style.display='';
    }

    closeBtn.addEventListener('click',closePopup);

    overlay.addEventListener('click',function(e){
      if(e.target===overlay) closePopup();
    });

    document.addEventListener('click',function(e){
      var trigger=e.target.closest('.self-notify-trigger');
      if(!trigger) return;
      e.stopImmediatePropagation();
      var wrap=trigger.closest('.self-notify-wrap');
      if(!wrap) return;
      openPopup(wrap);
    },true);

    form.addEventListener('submit',function(e){
      e.preventDefault();
      var email=emailEl.value.trim();
      if(!email||!email.includes('@')){
        msgEl.textContent='please enter a valid email.';
        msgEl.style.display='block';
        return;
      }
      submitBtn.disabled=true;
      fetch('https://bis.scriptengine.net/api/subscribe',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          shopify_id:61185097921,
          shopify_store_id:417,
          product_id:String(activeProductId),
          variant_id:String(activeVariantId),
          receiver_email:email,
          receiver_name:'',
          active_currency:'EGP',
          customer_id:0,
          is_integration:0,
          locale:'en'
        })
      })
      .then(function(){
        sizesEl.style.display='none';
        subtitleEl.style.display='none';
        form.style.display='none';
        titleEl.style.display='none';
        msgEl.innerHTML='<h2 style="font-size:22px;font-weight:500;text-align:center;margin:16px 0;">we\'ll email when she\'s back💅🏼</h2>';
        msgEl.style.display='block';
        setTimeout(closePopup,2000);
      })
      .catch(function(){
        sizesEl.style.display='none';
        subtitleEl.style.display='none';
        form.style.display='none';
        titleEl.style.display='none';
        msgEl.innerHTML='<h2 style="font-size:22px;font-weight:500;text-align:center;margin:16px 0;">we\'ll email when she\'s back💅🏼</h2>';
        msgEl.style.display='block';
        setTimeout(closePopup,2000);
      });
    });

    /* PDP variant change handler */
    var pdpWrap=document.querySelector('.self-notify-pdp');
    if(pdpWrap){

      function checkVariantAvailability(){
        var atcBtn=document.querySelector('.m-add-to-cart');
        if(!atcBtn) return;
        var variantInput=document.querySelector('input[name="id"]');
        if(variantInput) pdpWrap.dataset.variantId=variantInput.value;
        var isSoldOut=atcBtn.hasAttribute('disabled')||(atcBtn.textContent||'').toLowerCase().includes('sold');
        pdpWrap.style.display=isSoldOut?'block':'none';
      }

      document.addEventListener('theme:variant:change',function(e){
        if(!e.detail||!e.detail.variant) return;
        pdpWrap.dataset.variantId=String(e.detail.variant.id);
        pdpWrap.style.display=e.detail.variant.available?'none':'block';
      });

      document.addEventListener('theme:product:update',checkVariantAvailability);

      var productSection=document.querySelector('.main-product__block-buy_buttons, .m-product-form--main');
      if(productSection){
        var observer=new MutationObserver(function(){
          checkVariantAvailability();
        });
        observer.observe(productSection,{
          attributes:true,
          attributeFilter:['disabled','class'],
          childList:true,
          subtree:true,
          characterData:true
        });
      }

      document.addEventListener('click',function(e){
        var variantBtn=e.target.closest('.m-product-option--item, [data-option-value], .m-variant-option, .m-product-option');
        if(!variantBtn) return;
        setTimeout(checkVariantAvailability,100);
        setTimeout(checkVariantAvailability,500);
      });

      var pollCount=0;
      var poll=setInterval(function(){
        checkVariantAvailability();
        pollCount++;
        if(pollCount>=20) clearInterval(poll);
      },200);
    }

  } /* end of setup() */

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',setup);
  } else {
    setup();
  }
})();